import styled from "styled-components";
import {CssRule} from "../../../../../themes/architecture/css-helpers/css-rule";

export const VideoSlideFooterLayoutBox = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    bottom: 0;
    align-items: start;
    width: 100%;
    padding: 0px 16px 32px 16px;
    align-items: stretch;


    ${CssRule.For.mobile.embededHybrid.build()} & {
      bottom: 1rem;
    }
`;
